import { Box, Typography } from "@mui/material";
import { MenuItemStyle } from "./ParticipantStyles";

type Props = {
  active: boolean;
  label: string;
  value: string;
  handleClick: (value: string) => void;
};

const TabMenuItem = ({ active, label, value, handleClick }: Props) => {
  return (
    <Box
      sx={{
        ...MenuItemStyle,
        borderColor: active ? "primary.main" : "#E5E7EB",
        bgcolor: active ? "secondary.main" : "transparent",
      }}
      onClick={() => handleClick(value)}
    >
      <Typography
        variant="subtitle1"
        fontWeight={active ? "medium" : "regular"}
        color={active ? "primary.main" : "text.secondary"}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default TabMenuItem;
